import React from 'react'
import {Comment} from "../../Components/List/Item/CommentsItem";
import styles from "../../../CSS/main.css";
import Button from "../../Components/Button/Button";

type Props = {
  comment: Comment
  onApprove: () => void
  onBlock: () => void
}

const CommentActions: React.VFC<Props> = ({comment, onBlock, onApprove}) => {
  return (
    <>
      <Button
        onClick={!comment.approved || comment.rejected  ? onApprove : null}
        additionalClassNames={[
          styles.ButtonCombo,
          styles.IconAdminApprove,
          ...(comment.approved ? [styles.IconAdminApproved] : []),
        ]}>
        {comment.approved ? 'Approved' : 'Approve'}
      </Button>
      <Button
        onClick={!comment.rejected ? onBlock : null}
        additionalClassNames={[
          styles.ButtonCombo,
          styles.IconAdminBlock,
          ...(comment.rejected ? [styles.IconAdminBlocked] : []),
        ]}>
        {comment.rejected ? 'Blocked' : 'Block'}
      </Button>
    </>
  )
}

export default CommentActions
